module.exports = __webpack_public_path__ + "static/media/community.a1d077a3.png";